import { inject, type Component } from "vue"

interface RemoteValidator {
    validate(ruleId: "phone", request: { phoneNumber: string }): Promise<{ valid: boolean }>
    validate(ruleId: "zipCodeState", request: { zipCode: string; state: string }): Promise<{ valid: boolean }>
    validate(ruleId: "email", request: { email: string }): Promise<{ valid: boolean }>
}

export interface VCForm {
    applyValidator<T>(target: unknown, field: string, validatorId: string, validator: (value: T) => boolean): void
    applyValidator(target: unknown, field: string, validatorId: "required", validator: boolean): void
    applyValidator(target: unknown, field: string, validatorId: "requireTrue", validator: boolean): void
    applyValidator(target: unknown, field: string, validatorId: "requireAny", validator: boolean): void
    applyValidator(target: unknown, field: string, validatorId: "minLength", validator: number): void
    applyValidator(target: unknown, field: string, validatorId: "maxLength", validator: number): void
    applyValidator(target: unknown, field: string, validatorId: "minSelections", validator: number): void
    applyValidator(target: unknown, field: string, validatorId: "maxSelections", validator: number): void
    applyValidator(target: unknown, field: string, validatorId: "minValue", validator: number): void
    applyValidator(target: unknown, field: string, validatorId: "maxValue", validator: number): void
    applyValidator(target: unknown, field: string, validatorId: "minDate", validator: Date | number): void
    applyValidator(target: unknown, field: string, validatorId: "maxDate", validator: Date | number): void
    applyValidator(target: unknown, field: string, validatorId: "notInPast", validator: boolean): void
    applyValidator(target: unknown, field: string, validatorId: "noPoBox", validator: boolean): void
    applyValidator(target: unknown, field: string, validatorId: "requireOne", validator: Array<string>): void
    remoteValidator: RemoteValidator
    registerInput(input: Component): void
    deregisterInput(input: Component): void
    errorMessage(field: string, error: { id: string; message: string; params?: never[]; $remote: boolean }): string
    defaultErrorMessage: string
    updateInput(input: Component): void
    isValid(): boolean
}

export const useVCForm = (): VCForm | null => {
    return inject<VCForm>("vcform") ?? null
}
